import { en } from '@formkit/i18n';
import type { DefaultConfigOptions } from '@formkit/vue';
import { generateClasses } from '@formkit/themes';
import { genesisIcons } from '@formkit/icons';
import formkitTailwindTheme from './formkit-tailwind-theme';

const config: DefaultConfigOptions = {
  locales: { en },
  locale: 'en',
  /*
    TODO: This might not be needed, but adding for now because the installation
    instructions say to add it. https://formkit.com/getting-started/installation
   */
  icons: {
    ...genesisIcons,
  },
  config: {
    classes: generateClasses(formkitTailwindTheme),
  },
};

export default config;
